import { render, staticRenderFns } from "./home-slogan.vue?vue&type=template&id=3a518334"
import script from "./home-slogan.vue?vue&type=script&lang=js"
export * from "./home-slogan.vue?vue&type=script&lang=js"
import style0 from "./home-slogan.vue?vue&type=style&index=0&id=3a518334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports